import { z } from 'zod';

/**
 * Общие контракты paint-домена, переиспользуемые между `paint.ts`,
 * `paint-match.ts` и `api-client/paint.ts` (Block 3 Phase 2, B-039).
 *
 * Извлечено из `paint.ts` при появлении 3-го consumer'а — `apiClient.paint`
 * валидирует `ralCodes` query param через ту же схему. Симметрично
 * `decor-match.ts` импортирует дискриминатор/Lab из `decors.ts` без обратной
 * зависимости.
 *
 * См. ADR-0010 §1, B-039 (closed Block 3 Phase 2 Шаг 0).
 */

// RAL classic стандарт: «RAL» + пробел + 4 цифры (1000..9023, не все заняты).
// Регекс — формат-only, не проверка существования. Точная vocabulary-проверка
// (213 кодов) — admin-import Phase 4+, см. B-038.
export const RAL_CODE_REGEX = /^RAL \d{4}$/;
export const RalCodeSchema = z.string().regex(RAL_CODE_REGEX);
export type RalCode = z.infer<typeof RalCodeSchema>;
